'use strict';

import Router from "../../vendor/tightenco/ziggy/src/js/Router.js";

/**
 * @param name {ZiggyRouteList}
 * @param params {any}
 * @param absolute {boolean}
 */
export default function route(name, params = [], absolute = true) {
	try {
		const router = new Router(name, params, absolute, window.Ziggy);
		
		return name ? router.toString() : router;
	} catch (e) {
		// Only send to bugsnag if this happened *after* the whole page has loaded
		// (this is necessary because Alpine might try to render :href="" tags before
		// all the dynamic javascript is loaded).
		if ('complete' === document.readyState && 'bugsnagClient' in window) {
			window.bugsnagClient.notify(e);
		}
		
		// Always show the error locally, though
		console.error(e);
		
		return 'https://www.nachi.org/';
	}
};
